<template>
  <v-dialog v-model="show">
    <v-card class="mt-2">
      <v-card-title primary-title>
        <span class="headline mb-0">通関業者編集</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="save">{{$t('app.buttons.save')}}</v-btn>
        <v-btn @click="back">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                return-object
                url="divisions/kv"
                v-model="query.bu"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="海外取引先"
                return-object
                url="companies/kv?type=PARTNER"
                v-model="query.partner"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.dischargePort')"
                clearable
                return-object
                url="ports/kv"
                v-model="query.port"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['companyId', 'custom'],
  data() {
    return {
      query: {},
      show: false,
      buUrl: `divisions/kv?type=BU&companyId=${this.companyId}`
    }
  },
  methods: {
    popup() {
      this.show = true
    },
    save() {
      this.custom.buId = this.query.bu.value
      this.custom.buName = this.query.bu.text
      this.custom.portCode = this.query.port.value
      this.custom.portName = this.query.port.text
      this.custom.partnerId = this.query.partner.value
      this.custom.partnerName = this.query.partner.text
      // this.query = {}
      this.show = false
    },
    back() {
      this.query = {}
      this.show = false
    }
  },
  watch: {
    custom() {
      if (this.custom) {
        this.$set(this.query, 'bu', {
          value: this.custom.buId,
          text: this.custom.buName
        })
        this.$set(this.query, 'port', {
          value: this.custom.portCode,
          text: this.custom.portName
        })
        this.$set(this.query, 'partner', {
          value: this.custom.partnerId,
          text: this.custom.partnerName
        })
      }
    }
  }
}
</script>
